export default __webpack_public_path__ + "6dc47eb158af5d39dcc7c80b72044fdd.svg";